/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import configEnv from '../../../config';

const { MMO_EDIT_URL, MMO_ORIGIN } = configEnv;

const styles = (theme) => ({
    mmoModel: {
        padding: 0,
        margin: 0,
        width: '100%',
        minWidth: 310,
    },
    main: {
        '& > div > div': {
            padding: 0,
            paddingTop: 10,
            boxShadow: 'none',
            margin: '0 auto!important',
            width: '100%',
            background: 'transparent',
            overflow: 'hidden',
        },
    },
    contentHeight: {
        minHeight: 370,
        margin: '0 auto',
        display: 'block',
        boxShadow: 'none',
    },
    closeButton: {
        position: 'absolute',
        right: 5,
        minWidth: 5,
        top: 0,
        background: '#d20909', // for close button only
        color: '#fff', // for close button only
        height: 25,
        borderRadius: 15,
        padding: 0,
    },
    closeButtonColor: {
        color: '#fff', // for close button only
    },
    iframeColor: {
        background: '#fff', // for MMO only
    },
    mmoIframe: {
        [theme.breakpoints.up('sm')]: {
            minWidth: '100% !important',
        },
    },
});

class ModifyOrder extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            iframeLoading: true,
        };
    }

    loadIframe() {
        this.setState({ iframeLoading: false });
    }

    render() {
        const {
            classes,
            mmoOpen,
            action,
            token,
            orderId,
            itemDetail,
            intOrderNumber,
            brandOrderNum,
            storeID,
        } = this.props;
        const { iframeLoading } = this.state;
        const itemDetailObject = itemDetail[0];
        if (typeof itemDetailObject === 'undefined') {
            return <>{null}</>;
        }
        const {
            recipientSeqNumber,
            productBrand,
            sequenceNumber,
            parentLineNumber,
            childLineNumber,
            itemLineId,
            promCode,
            fulfillSku,
        } = itemDetailObject;
        const promo = promCode;
        const URL = `${MMO_EDIT_URL}${'?'}${'action='}${action}${'&storeId='}${storeID}${'&brandOrderNo='}${brandOrderNum}${'&intOrderNo='}${intOrderNumber}${'&lineItemId='}${itemLineId}${'&fulfillSku='}${fulfillSku}${'&cln='}${childLineNumber}${'&pln='}${parentLineNumber}${'&sequenceNo='}${sequenceNumber}${'&promCode='}${promo}${'&recipSequenceNo='}${recipientSeqNumber}${'&origin='}${MMO_ORIGIN}${'&token='}${token}${'&orderId='}${orderId}${'&brandId='}${productBrand}`;

        return (
            <>
                <Dialog scroll="body" className={classes.main} open={mmoOpen}>
                    <DialogContent
                        className={`${classes.contentHeight} ${classes.mmoModel}`}
                    >
                        <iframe
                            style={
                                !iframeLoading
                                    ? {
                                        background: 'transparent',
                                        border: 0,
                                        minHeight: 600,
                                        minWidth: 325,
                                    }
                                    : null
                            }
                            id="mmo-iframe"
                            onLoad={() => this.loadIframe()}
                            scrolling="no"
                            className={`${classes.mmoIframe} ${classes.contentHeight} ${classes.iframeColor}`}
                            title="Modify My Order"
                            src={URL}
                        />
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}

ModifyOrder.defaultProps = {
    mmoOpen: false,
};

ModifyOrder.propTypes = {
    classes: PropTypes.object.isRequired,
    mmoOpen: PropTypes.bool,
    action: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired,
    itemDetail: PropTypes.array.isRequired,
    intOrderNumber: PropTypes.string.isRequired,
    brandOrderNum: PropTypes.string.isRequired,
    storeID: PropTypes.number.isRequired,
};

const getStoreId = (state) => {
    const { ui: { brandId } } = state;
    const { storeId } = state.page.brands.byId[brandId];
    return storeId || '';
};

const mapStateToProps = (state) => ({
    storeID: getStoreId(state),
});

export default connect(mapStateToProps)(withStyles(styles)(ModifyOrder));
